import { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallBack } from '../shared/ErrorBoundary';

export function ComponentErrorBoundary({ children }: PropsWithChildren) {
  return <ErrorBoundary FallbackComponent={ErrorFallBack}>{children}</ErrorBoundary>;
}
